import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'
import { _apiRequestWrap } from '../apiService'

function _getRegulationsStagesPlanWorksProducts(options = {}) {
	return _apiRequestWrap(
		ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_PRODUCTS,
		ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_PRODUCTS]
			.GET_REGULATIONS_STAGES_PLAN_WORKS_PRODUCTS,
		options
	)
}
function _getRegulationsStagesPlanWorksProductPreview(options = {}) {
	return _apiRequestWrap(
		ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_PRODUCTS,
		ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_PRODUCTS]
			.GET_REGULATIONS_STAGES_PLAN_WORKS_PRODUCT_PREVIEW,
		options
	)
}
function _getRegulationsStagesPlanWorksProductPopup(options = {}) {
	return _apiRequestWrap(
		ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_PRODUCTS,
		ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_PRODUCTS]
			.GET_REGULATIONS_STAGES_PLAN_WORKS_PRODUCT_POPUP,
		options
	)
}

function _createRegulationsStagesPlanWorksProduct(options = {}) {
	return _apiRequestWrap(
		ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_PRODUCTS,
		ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_PRODUCTS]
			.CREATE_REGULATIONS_STAGES_PLAN_WORKS_PRODUCT,
		options
	)
}

function _getRegulationsStagesPlanWorksProduct(options = {}) {
	return _apiRequestWrap(
		ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_PRODUCTS,
		ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_PRODUCTS]
			.GET_REGULATIONS_STAGES_PLAN_WORKS_PRODUCT,
		options
	)
}

function _patchRegulationsStagesPlanWorksProduct(options = {}) {
	return _apiRequestWrap(
		ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_PRODUCTS,
		ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_PRODUCTS]
			.PATCH_REGULATIONS_STAGES_PLAN_WORKS_PRODUCT,
		options
	)
}

function _putRegulationsStagesPlanWorksProduct(options = {}) {
	return _apiRequestWrap(
		ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_PRODUCTS,
		ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_PRODUCTS]
			.PUT_REGULATIONS_STAGES_PLAN_WORKS_PRODUCT,
		options
	)
}

function _deleteRegulationsStagesPlanWorksProduct(options = {}) {
	return _apiRequestWrap(
		ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_PRODUCTS,
		ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_PRODUCTS]
			.DELETE_REGULATIONS_STAGES_PLAN_WORKS_PRODUCT,
		options
	)
}

export default {
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_PRODUCTS]
		.GET_REGULATIONS_STAGES_PLAN_WORKS_PRODUCTS]: _getRegulationsStagesPlanWorksProducts,
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_PRODUCTS]
		.GET_REGULATIONS_STAGES_PLAN_WORKS_PRODUCT_PREVIEW]: _getRegulationsStagesPlanWorksProductPreview,
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_PRODUCTS]
		.GET_REGULATIONS_STAGES_PLAN_WORKS_PRODUCT_POPUP]: _getRegulationsStagesPlanWorksProductPopup,
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_PRODUCTS]
		.CREATE_REGULATIONS_STAGES_PLAN_WORKS_PRODUCT]: _createRegulationsStagesPlanWorksProduct,
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_PRODUCTS]
		.GET_REGULATIONS_STAGES_PLAN_WORKS_PRODUCT]: _getRegulationsStagesPlanWorksProduct,
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_PRODUCTS]
		.PATCH_REGULATIONS_STAGES_PLAN_WORKS_PRODUCT]: _patchRegulationsStagesPlanWorksProduct,
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_PRODUCTS]
		.PUT_REGULATIONS_STAGES_PLAN_WORKS_PRODUCT]: _putRegulationsStagesPlanWorksProduct,
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_PRODUCTS]
		.DELETE_REGULATIONS_STAGES_PLAN_WORKS_PRODUCT]: _deleteRegulationsStagesPlanWorksProduct,
}
